import { compose } from "redux";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import {
  STATE_IDENTIFIER,
  TemplateSmsItem,
  TemplateSmsRawItem,
} from "./constants";
import emptyState from "./emptyState";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

const { CALL_STATE, LOADING, OPERATIONS, OPERATIONS_RAW, SELECTED_OPERATION } =
  STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_TEMPLATE_SMS_OPERATIONS]: (state: any, action: any) =>
    immutableSet([LOADING], true, state),
  [actionTypes.GET_TEMPLATE_SMS_OPERATIONS_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const displayedOperations = action.payload.map((op: any) => {
      let tempOp: TemplateSmsItem = {
        description: op.description,
        smsOperation: op.operation,
        uniqueId: op.id,
      };
      return tempOp;
    });
    const rawOperations = action.payload.map((op: any) => {
      let tempOp: TemplateSmsRawItem = {
        ...op,
        smsOperation: op.operation,
        uniqueId: op.id,
      };
      return tempOp;
    });
    return compose(
      immutableSet([LOADING], false),
      immutableSet([OPERATIONS], displayedOperations),
      immutableSet([OPERATIONS_RAW], rawOperations)
    )(state);
  },
  [actionTypes.GET_TEMPLATE_SMS_OPERATIONS_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([LOADING], false, state),

  [actionTypes.SELECT_OPERATION]: (state: any, action: any) =>
    immutableSet([SELECTED_OPERATION], action.payload, state),
  [actionTypes.UPDATE_TEMPLATE_SMS_OPERATION]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.UPDATE_TEMPLATE_SMS_OPERATION_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.UPDATE_TEMPLATE_SMS_OPERATION_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
